import { create } from "zustand";
import {
  getNovedades,
  getEventos,
  getTestimonioById,
  getTestimonioMarcas,
  getTestimonioUSer,
  getClientes,
  getHomeHero,
  getHeroInsurances,
  getHeroComex,
  getBeneficiosComex,
  getAutomotrizComex,
  getContactoComex,
  getMarcasComex,
  getTestimonioComex,
  getVideoComex,
  getCertificaciones,
  getContactosHeroes,
  getMreHeroes,
  getNosotrosHeroes,
  getNosotrosTeams,
  getPayHeroes,
  getSmartReaderHeroes,
  getMisimHeroes,
  getMisimTestimonios,
  getMisimClientes,
  getEventoHeroes,
  getBlogHeroes,
} from "../services/api";

const useStore = create((set) => ({
  novedades: [],
  eventos: [],
  testimonioclientes: [],
  testimonioMarcas: [],
  testimonioUser: [],
  clientes: [],
  heroComex: [],
  beneficiosComex: [],
  home: [],
  insurances: [],
  automotrizComex: [],
  contactoComex: [],
  marcasComex: [],
  testimonioComex: [],
  videoComex: [],
  certificacion: [],
  loading: false,
  // videoUrl:
  //   "https://api.institucional.global.sidom.io/uploads/web_fondo_comp_1_2800fd4092.mp4",
  // setVideoUrl: (url) => set({ videoUrl: url }),
  setVideoUrlError: (error) => set({ videoUrlError: error }),
  videoUrlError: null,
  videoPlaceholder: require("../assets/images/sidom/fotos/hero.PNG"),
  setVideoPlaceholder: (url) => set({ videoPlaceholder: url }),

  fetchNovedades: async () => {
    try {
      set({ loading: true });
      const data = await getNovedades();
      set({ novedades: data?.data || [], loading: false });
    } catch (error) {
      console.error("Error fetching novedades:", error);
      set({ loading: false });
    }
  },

  fetchEventos: async () => {
    try {
      set({ loading: true });
      const data = await getEventos();
      set({ eventos: data?.data || [], loading: false });
    } catch (error) {
      console.error("Error fetching eventos:", error);
      set({ loading: false });
    }
  },

  fetchTestimonioById: async () => {
    try {
      set({ loading: true });
      const data = await getTestimonioById();

      if (Array.isArray(data)) {
        set({ testimonioclientes: data, loading: false });
      } else {
        console.warn(
          "La respuesta de la API no contiene un array esperado:",
          data
        );
        set({ testimonio: [], loading: false });
      }

      return data;
    } catch (error) {
      console.error("Error fetching testimonio by id:", error);
      set({ loading: false });
      return null;
    }
  },
  getTestimonioMarcas: async () => {
    try {
      set({ loading: true });
      const data = await getTestimonioMarcas();

      set({ testimonioMarcas: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching marcas:", error);
      set({ loading: false });
    }
  },
  getTestimonioUSer: async () => {
    try {
      set({ loading: true });
      const data = await getTestimonioUSer();

      if (Array.isArray(data)) {
        set({ testimonioUser: data, loading: false });
      } else {
        console.warn(
          "La respuesta de la API no contiene un array esperado:",
          data
        );
        set({ testimonioUser: [], loading: false });
      }

      return data;
    } catch (error) {
      console.error("Error fetching testimonio by id:", error);
      set({ loading: false });
      return null;
    }
  },
  fetchClientes: async () => {
    try {
      set({ loading: true });
      const data = await getClientes();

      if (Array.isArray(data)) {
        set({ clientes: data, loading: false });
      } else {
        console.warn(
          "La respuesta de la API no contiene un array esperado:",
          data
        );
        set({ clientes: [], loading: false });
      }

      return data;
    } catch (error) {
      console.error("Error fetching clientes:", error);
      set({ loading: false });
      return null;
    }
  },
  getHomeHero: async () => {
    try {
      set({ loading: true });
      const data = await getHomeHero();

      set({ home: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching marcas:", error);
      set({ loading: false });
    }
  },
  getHeroInsurances: async () => {
    try {
      set({ loading: true });
      const data = await getHeroInsurances();
      set({ insurances: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching hero insurances:", error);
      set({ loading: false });
    }
  },
  getHeroComexBox: async () => {
    try {
      set({ loading: true });
      const data = await getHeroComex();

      set({ heroComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching hero insurances:", error);
      set({ loading: false });
    }
  },
  getBeneficiosComex: async () => {
    try {
      set({ loading: true });
      const data = await getBeneficiosComex();
      set({ beneficiosComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching beneficios-comexes:", error);
      set({ loading: false });
    }
  },
  getAutomotrizComex: async () => {
    try {
      set({ loading: true });
      const data = await getAutomotrizComex();
      set({ automotrizComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching automotriz-comexes:", error);
      set({ loading: false });
    }
  },
  getContactoComex: async () => {
    try {
      set({ loading: true });
      const data = await getContactoComex();
      set({ contactoComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching contacto-comexes:", error);
      set({ loading: false });
    }
  },
  getMarcasComex: async () => {
    try {
      set({ loading: true });
      const data = await getMarcasComex();
      set({ marcasComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching marcas-comexes:", error);
      set({ loading: false });
    }
  },
  getTestimonioComex: async () => {
    try {
      set({ loading: true });
      const data = await getTestimonioComex();
      set({ testimonioComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching testimonio-comexes:", error);
      set({ loading: false });
    }
  },
  getVideoComex: async () => {
    try {
      set({ loading: true });
      const data = await getVideoComex();
      set({ videoComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching video-comexes:", error);
      set({ loading: false });
    }
  },
  getCertificacionesAll: async () => {
    try {
      set({ loading: true });
      const data = await getCertificaciones();
      set({ certificacion: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching video-comexes:", error);
      set({ loading: false });
    }
  },
  contactosHeroes: [],
  mreHeroes: [],
  nosotrosHeroes: [],
  nosotrosTeams: [],
  payHeroes: [],
  smartReaderHeroes: [],
  misimHeroes: [],
  misimTestimonios: [],
  misimClientes: [],
  eventoHeroes: [],
  blogHeroes: [],

  getContactosHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getContactosHeroes();

      set({ contactosHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching contactos-heroes:", error);
      set({ loading: false });
    }
  },
  getMreHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getMreHeroes();
      set({ mreHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching mre-heroes:", error);
      set({ loading: false });
    }
  },
  getNosotrosHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getNosotrosHeroes();

      set({ nosotrosHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching nosotros-heroes:", error);
      set({ loading: false });
    }
  },
  getNosotrosTeams: async () => {
    try {
      set({ loading: true });
      const data = await getNosotrosTeams();
      set({ nosotrosTeams: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching nosotros-teams:", error);
      set({ loading: false });
    }
  },
  getPayHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getPayHeroes();
      set({ payHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching pay-heroes:", error);
      set({ loading: false });
    }
  },
  getSmartReaderHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getSmartReaderHeroes();
      set({ smartReaderHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching smart-reader-heroes:", error);
      set({ loading: false });
    }
  },
  getMisimHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getMisimHeroes();
      set({ misimHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching misim-heroes:", error);
      set({ loading: false });
    }
  },
  fetchMisimTestimonios: async () => {
    try {
      set({ loading: true });
      const data = await getMisimTestimonios();
      set({ misimTestimonios: data?.data || [], loading: false });
    } catch (error) {
      console.error("Error fetching misim-testimonios:", error);
      set({ loading: false });
    }
  },
  fetchMisimClientes: async () => {
    try {
      set({ loading: true });
      const data = await getMisimClientes();
      set({ misimClientes: data?.data || [], loading: false });
    } catch (error) {
      console.error("Error fetching misim-clientes:", error);
      set({ loading: false });
    }
  },
  getEventoHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getEventoHeroes();
      set({ eventoHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching evento-heroes:", error);
      set({ loading: false });
    }
  },
  getBlogHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getBlogHeroes();
      set({ blogHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching blog-heroes:", error);
      set({ loading: false });
    }
  },
}));

export default useStore;
